import { ClientSummaryList } from '@src/clients/domain/Client';
import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useQuery } from '@tanstack/react-query';

export const useClientsSummary = (
  { enabled }: { enabled: boolean } = { enabled: true },
) => {
  const { data: clientList = new ClientSummaryList([]), isLoading } =
    useQuery<ClientSummaryList>({
      queryKey: ['clientsSummary.list'],
      queryFn: ClientsClient.listSummary,
      enabled,
    });

  return {
    isLoading,
    clientList,
  };
};
